import { useNavigate } from "react-router-dom";
import seriesStore from "../stores/seriesStore";
import { filterSeries } from "../utils/filterSeries";

export default function PopularItems({selectedShow, setSelectedShow, selectedSeriesList, 
    setSelectedSeriesList, activeHeader, setActiveHeader}) {
    const navigate = useNavigate();
    const serStore = seriesStore();
 
    const filteredSeries2026  = filterSeries(serStore.series, { year: '2026' });
    const popularSeries  = filterSeries(serStore.series, { ids: ['696d1e224bb6bae767fe62b8', '697a831216cf6a9fd2355afb', 
      '6966d210e7e401c0b783d4cd', '697fac5b5658dc11316ebc74', '697a82f616cf6a9fd2355ac8'] });
    const hiddenGemsSeries  = filterSeries(serStore.series, { ids: ['696870cd0b38ca9f292f2c60', '69a9cbda3da7f2b2c50aff64', 
      '69992e1276a0f46aac8a7c7e', '69a9ddf48c353cfab9bab7bd', '69a9e2278c353cfab9baba3e'] });
    const phillySeries  = filterSeries(serStore.series, { ids: ['6967e0ba02418feac7c0e201', '69a9d6a53da7f2b2c50b0507', 
      '69a9de518c353cfab9bab949', '69a9dfa28c353cfab9baba1c', '696870d50b38ca9f292f2c90'] });

    return (
        <div className="popularItemsPage">
            <h3 className="popularItemsHeader">Popular Now</h3>
            <div className="series-list">
              {popularSeries?.map((s) => {

                return (
                <div className="series-card" key={s._id}
                onClick={() => {
                               navigate("/series", {  state: {
                                    selectedShow: s,
                                    selectedSeriesList: null,
                                    activeHeader: s._id
                                } });
                          }}>
                    <img
                      src={s.poster}
                      alt={s.title}
                      className="series-image"
                    />
                </div>
                );
              })}
          </div>

          <h3 className="popularItemsHeader">Philly Favorites</h3>
          <div className="series-list">
            {phillySeries?.map((s) => {

              return (
              <div className="series-card" key={s._id}
              onClick={() => {
                           navigate("/series", {  state: {
                                    selectedShow: s,
                                    selectedSeriesList: null,
                                    activeHeader: s._id
                                } });
                        }}>
                  <img
                    src={s.poster}
                    alt={s.title}
                    className="series-image"
                  />
              </div>
              );
            })}
        </div>

          <h3 className="popularItemsHeader">Hidden Gems</h3>
          <div className="series-list">
            {hiddenGemsSeries?.map((s) => {

              return (
              <div className="series-card" key={s._id}
              onClick={() => {
                            navigate("/series", {  state: {
                                    selectedShow: s,
                                    selectedSeriesList: null,
                                    activeHeader: s._id
                                } });
                        }}>
                  <img
                    src={s.poster}
                    alt={s.title}
                    className="series-image"
                  />
              </div>
              );
            })}
        </div>
        
        <h3 className="popularItemsHeader">Best of 2026</h3>
        <div className="series-list">
          {filteredSeries2026?.map((s) => {

            return (
            <div className="series-card" key={s._id}
            onClick={() => {
                          navigate("/series", {  state: {
                                    selectedShow: s,
                                    selectedSeriesList: null,
                                    activeHeader: s._id
                                } });
                      }}>
                <img
                  src={s.poster}
                  alt={s.title}
                  className="series-image"
                />
            </div>
            );
          })}
        </div>
      </div>
    )
}